const getNotify = (state) => state.notify;

export default {
    getNotify
}